export default {"src":"/_next/static/media/icon1.1abb819c.svg","height":44,"width":42};